module.exports = __webpack_public_path__ + "media/images/menu/triton-6b1d5b2a2e03e622bf3c5c47fdc72dc4.jpg";